import types from './types';
import childGalleryTypes from '../../ChildGallery/duck/types';

const initialState = {
  roomGalleryInformation: {}
};

export const roomGalleryReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ROOM_GALLERY_REQUEST: {
      return {
        ...state
      };
    }
    case types.GET_ROOM_GALLERY_SUCCESS: {
      return {
        ...state,
        roomGalleryInformation: action.dataGroupedByRoomId
      };
    }
    case childGalleryTypes.REMOVE_PHOTO_FROM_CHILD_GALLERY_SUCCESS: {
      // decrement 'child_photo_count' property so the child table for a room updates accordingly
      const updatedRoomGalleryInformation = { ...state.roomGalleryInformation };
      const { childId } = action;

      Object.values(updatedRoomGalleryInformation).forEach(room => {
        room.forEach(child => {
          if (parseInt(child.child_id, 10) === parseInt(childId, 10)) {
            child['child_photo_count'] = parseInt(child['child_photo_count'], 10) - 1;
          }
        });
      });

      return {
        ...state,
        roomGalleryInformation: updatedRoomGalleryInformation
      };
    }
    default:
      return state;
  }
};
